import { default as grid } from './grid/routes'

export default [
    ...grid
]